import axios from 'axios';
import queryString from 'query-string';

const parsed = queryString.parse(location.search || '') || {};
let urlPrefix = 'https://prod-mail.habbyservice.com/Kingrush';


if (location.hostname.includes('test-')) {
    urlPrefix = 'https://test-mail.habbyservice.com/Kingrush';
}

if (['localhost'].indexOf(location.hostname) >= 0) {
    urlPrefix = 'https://test-mail.habbyservice.com/Kingrush';

}

if (location.hostname.match(/[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+/)) {
    urlPrefix = 'https://test-mail.habbyservice.com/Kingrush';
}

if (parsed.local === '1') {
    urlPrefix = 'http://127.0.0.1:8888';
}


if (parsed.env == 'test') {
    urlPrefix = 'https://test-mail.habbyservice.com/Kingrush/';
}

if (parsed.env == 'prod') {
    urlPrefix = 'https://prod-mail.habbyservice.com/Kingrush';
}

function addURLPrefix(url) {
    if (url && url.charAt(0) === '/') {
        url = urlPrefix + url;
    }
    return url;
}

const headers = {
    habbysecret: ''
};

export const myHTTP = {
    get: function (url) {
        url = addURLPrefix(url);
        return axios.get(url);
    },
    post: function (url, data, val) {
        const config = {};
        url = addURLPrefix(url);
        return axios.post(url, data, config);
    },
    put: function (url, data) {
        const config = {};
        url = addURLPrefix(url);
        return axios.put(url, data, config);
    },
    delete: function (url, data) {
        const config = {};
        url = addURLPrefix(url);
        return axios.delete(url, config);
    }
}



// WEBPACK FOOTER //
// ./src/utils/net.js